/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {republishCashDisputeEvents} from '../api'

export const useMutationRepublishCashDisputeEvents = createReactQueryMutationHook('republishCashDisputeEvents', republishCashDisputeEvents)
